<template>
    <v-dialog
        v-model="isOpen"
        max-width="500"
    >
        <v-card>
            <v-card-title>
                Damaged - {{ article.sku }}
            </v-card-title>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DamagedModal',
    data() {
        return {
            isOpen: true
        }
    },
    props: {
        article: {
            type: Object,
            required: true
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close-modal');
            }
        }
    }
}
</script>